import { useLiveQuery } from "dexie-react-hooks";
import { Link } from "react-router-dom";
import { TextInput } from "../components/ui/Field";
import { Button } from "../components/ui/Button";
import { loadActiveContract } from "../db/contracts";
import { useAuthStore } from "../store/authStore";
import { getSyncClient } from "../sync/SyncClient";
import { useUnsavedGuard } from "../pwa/unsaved";
import { useEffect, useState } from "react";

export function SettingsPay() {
  const me = useAuthStore((s) => s.me);
  const readOnly = me?.role === "driver";
  const contract = useLiveQuery(() => loadActiveContract(), []);
  const [cutPct, setCutPct] = useState("");

  useEffect(() => {
    if (contract) setCutPct(String(contract.cutBps / 100));
  }, [contract]);
  useUnsavedGuard("settings-pay", !!contract && cutPct !== String(contract.cutBps / 100));

  async function save() {
    if (!contract || readOnly) return;
    const cutBps = Math.round(Number(cutPct) * 100);
    const now = new Date().toISOString();
    await getSyncClient().mutate({
      entity: "pay_contract",
      op: "upsert",
      id: contract.id,
      baseVersion: contract.version || null,
      patch: { cutBps },
      row: { ...contract, cutBps, updatedAt: now },
    });
  }

  return (
    <div className="stack">
      <Link to="/settings" className="muted back-link">
        ← Settings
      </Link>
      <h1 className="screen-title">Pay</h1>
      {readOnly ? (
        <p className="muted">Drivers can view pay settings but not edit.</p>
      ) : null}
      <div className="card stack">
        <div className="muted">{contract?.name ?? "No contract"}</div>
        <TextInput
          label="Cut %"
          placeholder="0"
          inputMode="decimal"
          value={cutPct}
          disabled={readOnly}
          onChange={(e) => setCutPct(e.target.value)}
        />
        {!readOnly ? (
          <Button variant="primary" onClick={() => void save()}>
            Save
          </Button>
        ) : null}
      </div>
    </div>
  );
}
